const config = {
    baseUrl: 'https://backend.ososweb.com',
    apiEndpoint: '/api/v1.0',
    // Add more configuration variables as needed
};

export default config;
